import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Services from "../components/Services";
import ForSchools from "../components/ForSchools";
import CourseFinderCTA from "../components/CourseFinderCTA";
import AssessmentCTA from "../components/AssessmentCTA";
import CounsellorRegister from "../components/CounsellorRegister";
import CounsellorsSection from "../components/CounsellorsSection";
import Reviews from "../components/Reviews";
import WhyChooseUs from "../components/WhyChooseUs";
import Contact from "../components/Contact";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const id = location.state?.scrollTo || (location.hash ? location.hash.slice(1) : null);
    if (id) {
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <main>
      <Hero />
      <Features />
      <Services />
      <ForSchools />
      <CourseFinderCTA />
      <AssessmentCTA />
      <Reviews />
      <WhyChooseUs />
      <CounsellorsSection />
      <CounsellorRegister />
      <Contact />
    </main>
  );
}
